const Accueil = resolve => {
    require.ensure(['./components/Accueil.vue'], () => {
        resolve(require('./components/Accueil.vue'));
    }, 'Accueil');
}
const ParticulierPage1 = resolve => {
    require.ensure(['./components/ParticulierPage1.vue'], () => {
        resolve(require('./components/ParticulierPage1.vue'));
    }, 'ParticulierPage1');
}
const ParticulierPage2 = resolve => {
    require.ensure(['./components/ParticulierPage2.vue'], () => {
        resolve(require('./components/ParticulierPage2.vue'));
    }, 'ParticulierPage2');
}
const ParticulierPage3 = resolve => {
    require.ensure(['./components/ParticulierPage3.vue'], () => {
        resolve(require('./components/ParticulierPage3.vue'));
    }, 'ParticulierPage3');
}
const ParticulierPage4 = resolve => {
    require.ensure(['./components/ParticulierPage4.vue'], () => {
        resolve(require('./components/ParticulierPage4.vue'));
    }, 'ParticulierPage4');
}
const ProPage1 = resolve => {
    require.ensure(['./components/ProPage1.vue'], () => {
        resolve(require('./components/ProPage1.vue'));
    }, 'ProPage1');
}
const ProPage2 = resolve => {
    require.ensure(['./components/ProPage2.vue'], () => {
        resolve(require('./components/ProPage2.vue'));
    }, 'ProPage2');
}
const Confirmation = resolve => {
    require.ensure(['./components/Confirmation.vue'], () => {
        resolve(require('./components/Confirmation.vue'));
    }, 'Confirmation');
}

export const routes = [
    {
        path: '', name: 'Home', components: {
            default: Accueil,
        },
    },
    {
        path: '/particulierpage1', name: 'particulierpage1', components: {
            default: ParticulierPage1,
        },
    },
    {
        path: '/particulierpage2', name: 'particulierpage2', components: {
            default: ParticulierPage2,
        },
    },
    {
        path: '/particulierpage3', name: 'particulierpage3', components: {
            default: ParticulierPage3,
        },
    },
    {
        path: '/particulierpage4', name: 'particulierpage4', components: {
            default: ParticulierPage4,
        },
    },
    {
        path: '/propage1', name: 'propage1', components: {
            default: ProPage1,
        },
    },
    {
        path: '/propage2', name: 'propage2', components: {
            default: ProPage2,
        },
    },
    {
        path: '/confirmation', name: 'confirmation', components: {
            default: Confirmation,
        },
    }
]


// WEBPACK FOOTER //
// ./src/routes.js